import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { toast } from 'sonner';

const LoginPage = () => {
  const [userType, setUserType] = useState('acquereur');
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="font-display text-4xl font-bold text-foreground mb-2">OMERO</h1>
          <p className="font-body text-muted-foreground">Portail immobilier inversé C2C</p>
        </div>
        
        <div className="bg-white rounded-lg border border-border p-8">
          <p className="font-body text-center mb-6">
            Utilisez le bouton "Connexion" dans le header pour vous connecter ou créer un compte.
          </p>
          <Button
            onClick={() => navigate('/')}
            className="w-full bg-black hover:bg-black/90 text-white"
          >
            Retour à l'accueil
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
